import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link as RouterLink } from 'react-router';
import { gtmSafeRedirect } from 'redux/saga/helpers';
import { isExternal, isExternalDomain } from 'helpers/path';

export class Link extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleExternalClick = this.handleExternalClick.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleExternalClick(event) {
    const { to } = this.props;

    this.handleClick();

    if (!isExternalDomain(to)) {
      event.preventDefault();
      gtmSafeRedirect(to);
    }
  }

  handleClick(...args) {
    const { onClick } = this.props;

    if (onClick) {
      onClick(...args);
    }
  }

  render() {
    const { className, children, forceReload, to } = this.props;

    return forceReload || isExternal(to) ? (
      <a
        className={className}
        href={to}
        onClick={this.handleExternalClick}
        {...(isExternalDomain(to) && {
          target: '_blank',
          rel: 'noopener noreferrer',
        })}>
        {children}
      </a>
    ) : (
      <RouterLink className={className} to={to} onClick={this.handleClick}>
        {children}
      </RouterLink>
    );
  }
}

Link.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  forceReload: PropTypes.bool,
  onClick: PropTypes.func,
  to: PropTypes.string.isRequired,
};
